import React from 'react';
import { StyleSheet } from 'react-native';

import { FadeView, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationLoadingOverlay = (props: Props) => {
  const { show } = props;

  return <FadeView show={show} style={styles.container} />;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
    backgroundColor: theme.colors.OPACITY.WHITE.DARKER,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  show: boolean;
};
